import axios, { AxiosPromise } from 'axios';
import {
  CommentaryDecisionSource,
  CommentaryLegislationSource,
} from './commentary.types';

export function trackCommentary(
  url: string,
  source: string,
  data: Object,
): void {
  axios.post('/track_comment', { url, source, data });
}

export function getCommentaryDecisionSourcesById(
  id: string,
): AxiosPromise<Array<CommentaryDecisionSource>> {
  return axios.get(`/api/commentaries/${id}/decisions`);
}

export function getCommentaryLegislationArticlesById(
  id: string,
): AxiosPromise<Array<CommentaryLegislationSource>> {
  return axios.get(`/api/commentaries/${id}/legislation/articles`);
}
